import styled, { css } from 'styled-components';

export const Container = styled.div`
	background: #f6f2e8;
	padding: 40px 0;
	color: #262524;
	position: relative;

	h1 {
		text-transform: uppercase;
		margin: 0;
		font-size: 2.8rem;
	}

	select {
		height: 68px !important;
		text-align: center;
	}

	@media (max-width: 768px) {
		h1 {
			font-size: 1.8rem;
		}
	}
`;

export const Loading = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #0006;
	z-index: 10;
`;

export const Location = styled.div`
	margin: 4px 0 0;
	display: flex;
	align-items: center;
	color: #931a1a;

	& > div {
		width: 24px;
	}

	& > span {
		font-weight: bold;
		text-transform: uppercase;
		margin: 0 0 0 4px;
		font-size: 1.4rem;
	}
`;

export const Inline = styled.div`
	margin: 24px 0 0;
	display: flex;
	align-items: flex-start;
	gap: 16px;

	& > * {
		width: 24%;
	}

	@media (max-width: 768px) {
		display: block;

		& > * {
			width: 100%;

			&:not(:first-child) {
				margin: 24px 0 0;
			}
		}
	}
`;

export const Button = styled.div<{ secondary?: boolean }>`
	color: #fff;
	background: #931a1a;
	text-transform: uppercase;
	height: 68px;
	padding: 0 32px;
	font-weight: bold;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	margin: 18px 0 0;
	cursor: pointer;
	border: 2px solid #931a1a;

	&:hover {
		opacity: 0.9;
	}

	${({ secondary }) => {
		if (secondary) {
			return css`
				background: transparent;
				color: #931a1a;
			`;
		}

		return null;
	}}
`;

export const Info = styled.div`
	margin: 32px 0 0;

	a {
		text-decoration: underline;

		&:hover {
			color: #931a1a;
		}
	}
`;

export const Grid = styled.div<{ columns: string }>`
	margin: 24px 0 0;
	display: grid;
	grid-template-columns: ${({ columns }) => columns};
	gap: 16px;

	@media (max-width: 768px) {
		display: block;

		& > *:not(:first-child) {
			margin: 16px 0 0;
		}
	}
`;

export const GuestInfoContainer = styled.div`
	select {
		margin: 7px 0 0;
		height: 70px !important;
	}
`;

export const Buttons = styled.div`
	margin: 24px 0 0;
	display: flex;
	gap: 16px;

	@media (max-width: 768px) {
		& > * {
			flex: 1;
		}
	}
`;

export const Modal = styled.div`
	background: #000a;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const ModalContent = styled.div`
	padding: 16px;
	background: #f6f2e8;
	margin: 0 16px;
`;

export const ModalClose = styled.div`
	display: flex;
	justify-content: flex-end;
	color: #a10000;

	& > * {
		cursor: pointer;

		&:hover {
			opacity: 0.7;
		}
	}
`;

export const ModalChildren = styled.div`
	margin: 16px 0 0;
	display: flex;
	flex-direction: column;
	align-items: center;

	h2 {
		text-transform: uppercase;
		text-align: center;
		margin: 0;
		font-size: 1.4rem;
		font-weight: bold;
	}

	p {
		margin: 24px 0 0;
		padding: 0 16%;
		text-align: center;
	}

	section {
		margin: 16px 0 0;
		width: 100%;
	}

	${() => {
		return css`
			${Button} {
				margin: 32px 0 0;
				padding-left: 48px;
				padding-right: 48px;
			}
		`;
	}}

	@media(max-width: 768px) {
		h2 {
			font-size: 1.2rem;
		}

		p {
			padding: 0 8%;
		}
	}
`;

export const Success = styled.div`
	margin: -40px 0;
	min-height: 90vh;
	background: url(https://edge.sitecorecloud.io/osi-60501bcc/media/Project/BBI/outback/Seating/seating-success-bg.webp)
		center no-repeat;
	background-size: cover;
`;

export const SuccessContent = styled.div`
	padding: 80px 32px 32px;
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #fff;
	text-transform: uppercase;
	max-width: 800px;
	margin: 0 auto;

	h1 {
		text-align: center;
		margin: 0;
		font-size: 3.4rem;
	}

	h2 {
		text-align: center;
		font-size: 1.8rem;
		margin: 0;
	}

	& > div {
		margin: 24px 0 0;
	}

	p {
		font-size: 1.8rem;
		text-align: center;
		text-transform: uppercase;
		font-weight: bold;
		margin: 32px 0 0;

		a {
			text-decoration: underline;

			&:hover {
				opacity: 0.8;
			}
		}
	}

	@media (max-width: 768px) {
		padding-top: 32px;

		& > div {
			order: 4;
			width: 100%;

			& > div {
				margin: 60px 0 0;
				width: 100%;
			}
		}
	}

	${() =>
		css`
			${Button} {
				background: transparent;
				border-color: #fff;
				transition: all ease 0.3s;

				&:hover {
					background: #fff;
					color: #000;
				}
			}
		`}
`;

export const Item = styled.div`
	strong {
		text-transform: uppercase;
		font-weight: bold;
		font-size: 1.2rem;
		border-bottom: 1px solid #e8dcc2;
	}

	p {
		margin: 12px 0 0;
		font-size: 1.2rem;

		a {
			text-decoration: underline;
			cursor: pointer;

			&:hover {
				color: #a10000;
			}
		}
	}
`;

export const DetailsButtons = styled.div`
	margin: 32px 0 0;
	display: flex;
	align-items: flex-end;

	p {
		margin: 0 0 0 24px;
		text-decoration: underline;
		cursor: pointer;

		&:hover {
			color: #a10000;
		}
	}
`;

export const ShareFields = styled.div`
	margin: 24px 0 0;
	width: 500px;

	& > *:not(:first-child) {
		margin: 12px 0 0;
	}

	@media (max-width: 768px) {
		width: unset;
	}
`;
